<template>
  <div class="content">
    <BlockUI
      v-if="this.blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    ></BlockUI>
    <v-card>
      <v-card-title>
        Engajamento Mensal
        <v-spacer></v-spacer>
      </v-card-title>
      <v-layout row wrap>
        <v-spacer></v-spacer>
        <v-flex xs4>
          <v-text-field
          v-model="approver"
          append-icon="search"
          label="Procurar"
          single-line
          hide-details
        ></v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs4>
          <v-dialog
            ref="dialog_begin"
            v-model="modal_begin"
            :return-value.sync="begin_date"
            persistent
            lazy
            max-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="begin_date"
                label="Período"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="begin_date"
              type="month"
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal_begin = false"
                >Cancel</v-btn
              >
              <v-btn
                flat
                color="primary"
                @click="$refs.dialog_begin.save(begin_date)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs2>
          <v-btn
            class="btn-block btn btn-primary mb-2 filtro-button"
            @click="filtrar()"
            >Filtrar</v-btn
          >
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
      <v-flex sm6 offset-sm10 offset-lg10>
        <download-excel
          class="ml-auto mr-0"
          :data="reservationGrid"
          :fields="json_fields"
          name="reservas.xls"
        >
          <v-btn small class="mr-4"
            ><span class="pr-1">Exportar</span
            ><v-icon small class="black--text">insert_drive_file</v-icon></v-btn
          >
        </download-excel>
      </v-flex>
      <br />
      <v-data-table
        no-data-text="nenhum dado encontrado"
        :headers="headers"
        :items="reservationGrid"
        :search="approver"
        item-key="name"
        group-key="category"
        class="elevation-1"
      >
        <!-- <template slot="group" slot-scope="props"> -->
        <!-- <span class="font-weight-bold">Serviço {{props.groupName}}</span> -->
        <!-- </template> -->
        <template v-slot:item="{ item }">
          <tr>
            <td class>{{ item.cliente }}</td>
            <td class>{{ item.estado }}</td>
            <td class>{{ item.data_mobilizacao }}</td>
            <td class>{{ item.receita_mensal | formatValue }}</td>
            <td class>{{ item.total_reservas }}</td>
            <td class>{{ item.ticket_medio | formatValue }}</td>
            <td class>{{ item.tdm | formatValue }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import VehicleRequestController from '../../controllers/VehicleRequestController';
import ConfigurationController from '../../controllers/ConfigurationController';
import moment from 'moment';
import Roles from '../../models/Roles';

export default {
  data() {
    return {
      profile: localStorage.getItem('profile'),
      header_color: 'blue',
      begin_date: moment()
        .format('YYYY-MM'),
      modal_begin: false,
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      reservationGrid: [],
      service: null,
      approver: '',
      pagination: {
        sortBy: 'cliente',
        descending: true,
      },
      json_fields: {
        Cliente: 'cliente',
        Estado: 'estado',
        Mobilizacao: 'data_mobilizacao',
        'Receita Mensal': 'receita_mensal',
        'Total Reservas': 'total_reservas',
        'Ticket Médio': 'ticket_medio',
        TDM: 'tdm',
      },
      headers: [
        { text: 'Cliente', value: 'cliente' },
        { text: 'Estado', value: 'estado' },
        { text: 'Mobilizacao', value: 'data_mobilizacao' },
        { text: 'Receita Mensal', value: 'receita_mensal' },
        { text: 'Total Reservas', value: 'total_reservas' },
        { text: 'Ticket Médio', value: 'ticket_medio' },
        { text: 'TDM', value: 'tdm' },
      ],
      configurations: {},
      configurationController: new ConfigurationController(this.$resource),
      vehicleRequestController: new VehicleRequestController(this.$resource),
    };
  },
  created() {
    this.loadData(this.begin_date);
  },
  methods: {
    filtrar() {
      this.loadData(this.begin_date);
    },

    async loadData(begin_date = null) {
      this.blockScreen = true;
      try {
        let response = null;
        if (this.profile == Roles.Tcs) {
          response = await this.vehicleRequestController.getEngagementReport(
            begin_date
          );
        }
        if (response.ok) {
          this.reservationGrid = response.data;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.blockScreen = false;
      }
    },

    formatHour(valor) {
      let horas = '00';
      let minutos = '00';
      if (valor.hours)
        if (valor.hours < 10) horas = '0' + valor.hours;
        else horas = valor.hours;
      if (valor.minutes)
        if (valor.minutes < 10) minutos = '0' + valor.minutes;
        else minutos = valor.minutes;
      return horas + ':' + minutos;
    },

    formatValue(value) {
      let valorFloat = parseFloat(value);
      let formatado = 'R$ ' + valorFloat.toFixed(2).replace('.', ',');
      return formatado;
    },
  },
  filters: {
    formatHour(valor) {
      let horas = '00';
      let minutos = '00';
      if (valor.hours)
        if (valor.hours < 10) horas = '0' + valor.hours;
        else horas = valor.hours;
      if (valor.minutes)
        if (valor.minutes < 10) minutos = '0' + valor.minutes;
        else minutos = valor.minutes;
      return horas + ':' + minutos;
    },

    formatValue(value) {
      let valorFloat = parseFloat(value);
      let formatado = 'R$ ' + valorFloat.toFixed(2).replace('.', ',');
      return formatado;
    },
  },
};
</script>

<style lang="scss">
.action-list button {
  float: right;
}
.table-custom-vue {
  margin: 20px;
}

.filtro-button {
  background: var(--primary-color-hover) !important;
}
</style>
